import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderRefreshService {
  private refreshSubject = new Subject<void>();

  triggerRefresh() {
    this.refreshSubject.next();
  }

  onRefresh() {
    return this.refreshSubject.asObservable();
  }
}
